import React from 'react';
import HeaderBrand from '../../components/ui/HeaderBrand';
import CounterGrid from '../../components/ui/CounterGrid';

const CallTrackerDashboard = () => {
  return (
    <div className="min-h-screen bg-background smooth-scroll">
      {/* Main Container */}
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-12">
        {/* Header Section */}
        <div className="mb-8 md:mb-12 lg:mb-16">
          <HeaderBrand />
        </div>

        {/* Counter Grid Section */}
        <CounterGrid />

        {/* Footer Section */}
        <footer className="mt-12 md:mt-16 lg:mt-20 pt-8 border-t border-border">
          <div className="text-center">
            <p className="text-sm md:text-base text-muted-foreground font-caption">
              &copy; {new Date()?.getFullYear()} CallTracker. All rights reserved.
            </p>
            <p className="text-xs md:text-sm text-muted-foreground mt-2 font-caption">
              Track your calls. Measure your success.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default CallTrackerDashboard;